// @flow
import React from 'react';
import useWindowDimensions from 'utils/windowDemensions';
import cn from 'classnames';
import { getResultColor } from '../../utils/resultColors';

import styles from './styles.module.scss';

type Props = {
  percent: number,
  base: number,
  className?: string,
}

const Diagram = ({ percent = 0, base = 0, className }: Props) => {
  const { width } = useWindowDimensions();
  const ratio = base > 0 ? (percent / base) * 100 : 0;
  const basePercent = Number.isFinite(ratio) ? Math.min(100, Math.max(0, ratio)) : 0;
  const color = getResultColor(basePercent);
  const radius = width >= 2200 ? 60 : 36;
  const circumference = 2 * Math.PI * radius;

  return (
    <div className={cn(styles.diagramWrapper, className)}>
      <span className={styles.percent} style={{ color: '#FFFFFF' }}>
        {`${Math.round(basePercent)}%`}
      </span>
      <svg
        className={styles.progressRing}
        viewBox={`0 0 ${width >= 2200 ? 160 : 80} ${width >= 2200 ? 160 : 80}`}
      >
        <circle
          className={styles.progressRingCircleMain}
          strokeWidth={width >= 2200 ? '14' : '7'}
          cx={width >= 2200 ? '80' : '40'}
          cy={width >= 2200 ? '80' : '40'}
          r={radius}
          fill="transparent"
        />
        <circle
          className={styles.progressRingCircle}
          style={{
            stroke: color,
            strokeDasharray: `${circumference} ${circumference}`,
            strokeDashoffset: circumference * (1 - basePercent / 100),
          }}
          strokeWidth={width >= 2200 ? '10' : '5'}
          strokeLinecap="round"
          cx={width >= 2200 ? '80' : '40'}
          cy={width >= 2200 ? '80' : '40'}
          r={radius}
          fill="transparent"
        />
      </svg>
    </div>
  );
};

export default Diagram;
